<template>
  <el-drawer
    title="Account Details"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <section class="px-8 py-6">
      <div>
        <div class="text-fg-muted">
          <ul>
            <li
              class="grid grid-cols-2 items-center font-normal text-sm border-b py-3.5 lg:py-6"
            >
              <span>Currency</span>
              <span class="flex items-center gap-x-2">
                <currency-icons
                  :currency="getCurrencyCountry(virtualAccountDetails.currency)"
                />
                <span class="capitalize">{{
                  virtualAccountDetails.currency
                }}</span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>Account Name</span>
              <span class="flex justify-between items-center gap-x-2">
                <span class="capitalize">{{
                  virtualAccountDetails.accountDetails.account_name || '-'
                }}</span>
                <span
                  class="cursor-pointer mb-1 ml-2"
                  v-clipboard:copy="
                    virtualAccountDetails.accountDetails.account_name
                  "
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>Bank Name</span>
              <span class="capitalize">{{
                virtualAccountDetails.accountDetails.bank_name || '--'
              }}</span>
            </li>
            <li
              class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
            >
              <span>
                {{ isCurrencyNGN ? 'Account No' : 'IBAN' }}
              </span>
              <span class="flex justify-between items-center gap-x-2">
                <span class="capitalize">
                  {{
                    isCurrencyNGN
                      ? virtualAccountDetails.accountDetails.account_number
                      : virtualAccountDetails.accountDetails.iban
                  }}
                </span>
                <span
                  class="cursor-pointer mb-1 ml-2"
                  v-clipboard:copy="
                    isCurrencyNGN
                      ? virtualAccountDetails.accountDetails.account_number
                      : virtualAccountDetails.accountDetails.iban
                  "
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </span>
            </li>
            <li
              class="grid grid-cols-2 items-center text-sm font-normal border-b py-3.5 lg:py-6"
            >
              <span>Reference</span>
              <span class="flex justify-between items-center gap-x-2">
                <span class="capitalize">{{
                  virtualAccountDetails.reference
                }}</span>
                <span
                  class="cursor-pointer mb-1 ml-2"
                  v-clipboard:copy="
                    virtualAccountDetails.accountDetails.reference
                  "
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </span>
            </li>
            <li
              v-if="!isCurrencyNGN"
              class="grid grid-cols-2 items-center border-b font-normal text-sm py-3.5 lg:py-6"
            >
              <span>Country</span>
              <div>
                {{ virtualAccountDetails.accountDetails.country || '--' }}
              </div>
            </li>
            <!-- no status in data response -->
            <!-- <li
              class="grid grid-cols-2 items-center border-b py-3.5 lg:py-6 font-normal"
            >
              <span>Status</span>
              <span class="flex items-center gap-x-2">
                <span
                  :class="statusClass(virtualAccountDetails.status)"
                  class="py-1.5 px-3 rounded-lg flex items-center gap-1"
                  >{{ formatServerName(virtualAccountDetails.status) }}</span
                >
              </span>
            </li> -->
          </ul>
        </div>
      </div>
    </section>
  </el-drawer>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import {
  GetCurrencyCountry,
  StatusClass,
  FormatServerName
} from '@/utils/helpers.js'
export default {
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    virtualAccountDetails: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue')
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isCurrencyNGN () {
      return this.virtualAccountDetails.currency === this.$CURRENCY.NGN
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    statusClass (status) {
      return StatusClass(status)
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    }
  }
}
</script>

<style scoped>
>>> .el-drawer__header > :first-child {
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 600;
}
>>> .el-drawer__header {
  color: var(--text-4);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-2);
}
>>> .el-drawer {
  background: var(--background-9) !important;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  margin: 0, 6px;
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 400;
  padding-left: 40px;
  background: var(--background-10);
}
.small-text {
  font-size: 0.6rem;
}
</style>
